import React from 'react';
import { Alert } from '../../ui-kit';
import moment from 'moment';

export const activityTypesFor = ({ activityTypes, groupId, appliesTo }) => {
  const result = {};
  for (const item of Object.values(activityTypes).filter(
    at => at.group_ids.includes(groupId) && at.applies_to === appliesTo
  )) {
    result[item.id] = item;
  }
  return result;
};

export const isLongerThan = (target, start_time, end_time) => {
  // if there is no end time, comparison is moot
  if (!end_time) return false;
  return moment(end_time).diff(moment(start_time), 'hours') >= target;
};

export const getWarningsFor = (activity, checkTypes) => {
  const { start_time, end_time, activity_type_ids } = activity;
  let warnings = {};
  // if the activity has no type
  if (checkTypes && activity_type_ids.length === 0) warnings['noType'] = I18n.t('activity_reports.empty_type');
  // if the activity is longer than 6 hours
  if (isLongerThan(6, start_time, end_time)) warnings['isLong'] = I18n.t('activity_reports.long_activity');

  if (!end_time) warnings['noEndTime'] = I18n.t('activity_reports.no_end_time');

  return warnings;
};

export const shouldSave = warnings => {
  const messages = Object.values(warnings);
  if (messages.length === 0) return true;
  // Prepare the message to be displayed in the window alert
  const message = messages.join('\n');
  return globalThis.confirm(`${message}\n${I18n.t('are_you_sure')}`);
};

export const ErrorAlert = ({ errors }) =>
  Object.keys(errors).length > 0 && (
    <Alert variant="danger">
      {Object.keys(errors).map(key => {
        return (
          <ul key={key}>
            {errors[key].map((error, index) => (
              <li key={index}>
                {I18n.t(`activerecord.attributes.incidents/activity_report.${key}`)}: {error}
              </li>
            ))}
          </ul>
        );
      })}
    </Alert>
  );

export const AlertWith = ({ warning }) => {
  return (
    <Alert className="condensed my-1 px-2" variant="warning">
      {warning}
    </Alert>
  );
};
